import React, { Component } from 'react';
import { Card, Column } from './styled/NoCallMessageStyled';
import Icon from '../Icon';

interface LocalizationLike {
    getText: (key: string) => string;
}
interface Props {
    localization: LocalizationLike;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class NoCallMessage extends Component<Props> {
    render() {
        const { localization } = this.props;

        return (
            <Card className="message">
                <Icon name="Headset" />
                <Column>
                    <span>{localization.getText('trainer.call_messages.not_started')}</span>
                </Column>
            </Card>
        );
    }
}
